import React from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { servicesData } from '../../utils/servicesData';

// styles
import 'swiper/css';
import 'swiper/css/pagination';
import { MdArrowDropDown } from 'react-icons/md';
const Services = ({show, close}) => {
  return (
    <ServicesWrapper>
      <div className="head">
        <div className="h-b">
          <span>|| Our Services</span>
          <h1>What We Offer</h1>
        </div>
        <div className="t-b">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam ipsa libero, quo harum sunt suscipit.</p>
        </div>
      </div> 
      <ServicesBox>
      <Swiper
            modules={[Pagination]}
            spaceBetween={20}
            breakpoints={{
              1028: { slidesPerView: 4 },
              884: { slidesPerView: 3 },
              768: {slidesPerView: 2},
              430: { slidesPerView: 1 },
            }}
            pagination={{ clickable: true }}
            className="swiper">
            {servicesData &&
              servicesData.map((offer) => (
                <SwiperSlide key={offer.id} className="slide" onClick={() => {show(!close)}}>
                 <div className="imgWrap">
                    <img src={offer.imgSrc} alt={offer.service} loading="lazy" />
                  </div>
                  <span className='ico'>
                    {offer.icoBox}
                  </span>
                  <div className="offer-abt">
                    <h3>{offer.service}</h3>
                    <p>{offer.caption.substring(0, 120)}.</p>
                  </div>
                  <div className="btn">
                    <p>{offer.btnText}</p>
                    <MdArrowDropDown />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
     </ServicesBox> 
    </ServicesWrapper>
  )
}

const ServicesWrapper = styled.section`
min-height: 100vh;
padding: 100px 20px;
 .head{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    .h-b{
        text-align: center;
        span{
            font-weight: 700;
        }
        h1{
            font-size: 2.03rem;
            font-weight: 700;
            padding: 10px 0;
        }
    }
    .t-b{
        display: flex;
        justify-content: center;
        p{
            font-size: 1.05rem;
            font-weight: 600;
            text-align: center;
            width: 60%;
            line-height: 1.7;
        }
    }
 } 
 @media screen and (max-width: 884px){
  padding: 50px 20px;
  min-height: 40vh;
 }

 @media screen and (max-width: 430px){
  padding: 50px 20px;
  min-height: 70vh;
  .head{
    width: 100%;
    .t-b{
      p{
         width: 95%;
      } 
    }
  }
 }
`

const ServicesBox = styled.article`
 min-height: 100vh;
 margin-top: 3%;
 .swiper{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .swiper-pagination-bullet{
        background: var(--bg-color);
        width: 15px;
        height: 15px;
    }
    .slide{
      position: relative;
      width: 300px;
      box-shadow: 0 0 10px var(--bga-color);
      background: #fff;
      border-radius: .2rem;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      transition: all 700ms ease-in-out;
      .imgWrap{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        img{
         border-radius: .2rem .2rem 0 0;
         width: 95%;
        }
      }

      .ico{
        position: absolute;
        top: 55%;
        right: 1rem;
        width: 45px;
        height: 45px;
        background: linear-gradient(192deg, var(--bg-color), var(--ico-color));
        border-radius: 50px;
        box-shadow: 0 0 0 5px var(--bga-color);
        display: flex;
        align-items: center;
        justify-content: center;
        .s-ico{
            font-size: 25px;
            color: var(--main-color);
        }
      }
       .offer-abt{
         padding: 0 10px;
            h3{
                padding: 5px 0;
                color: var(--bg-color);
                font-size: 1.5rem;
                font-weight: 700;
                margin-top: 5px;
            }
            p{
                font-size: 14px;
                line-height: 1.7;
                font-weight: 500;
                padding: 15px 0;
            }
       }
       .btn{
         cursor: pointer;
         display: flex;
         align-items: center;
         justify-content: space-between;
         background: rgb(0 0 0 / 5%);
         box-shadow: 0 .3rem 1rem rgb(255 255 255/ 20%);
         padding: 12px;
         width: 95%;
         p{
            font-size: 16px;
         }
       }
       
       &:hover{
        transform: translateY(5px);
       }
    }

    @media screen and (max-width: 884px){
       margin-top: 3%;
       min-height: 80vh;

       .swiper{
        min-height: 80vh;
       }
    }

    @media screen and (max-width: 430px){
       margin-top: 10px;
       min-height: 80vh;

       .swiper{
        min-height: 80vh;
        background: red;
       }
    }
 }
`

export default Services